export default __webpack_public_path__ + "static/media/steering-wheel.12212f6f.png";